export const LearnMoreSection2 = ({
  title,
  subTitle,
}: {
  title?: string
  subTitle?: string
}) => {
  return (
    <section className="LearnMoreSection2 wide">
      <hgroup className="centered-section-title">
        <h3>{title}</h3>
        <h4>{subTitle}</h4>
      </hgroup>

      <div className="grid cols2 call-out-cards">
        <a href="/business-intelligence" className="call-out-card">
          <div>
            <img
              src="/images/pages/snowflake/bar_chart_4_bars.svg"
              height="38"
            />
          </div>
          <div>
            <h4>Business intelligence</h4>
            <p>
              Explore data easily, build beautiful visualizations, and rapidly
              share findings—all in one place.
            </p>
            <button>Learn more</button>
          </div>
        </a>
        <div className="divider"></div>
        <a href="/embedded-analytics" className="call-out-card">
          <div>
            <img
              src="/images/pages/snowflake/data_thresholding.svg"
              height="29"
            />
          </div>
          <div>
            <h4>Embedded analytics</h4>
            <p>
              Speed up product development, increase customer engagement, and
              monetize your data.
            </p>
            <button>Learn more</button>
          </div>
        </a>
      </div>
    </section>
  )
}
